import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  HostBinding,
} from '@angular/core';

export type FlagType = 'reserved' | 'top' | '3d-tour';

@Component({
  selector: 'lib-list-card-flag',
  templateUrl: './list-card-flag.component.html',
  styleUrls: ['./list-card-flag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListCardFlagComponent {
  @Input()
  type: FlagType = 'reserved';

  @HostBinding('style.--background-color')
  get BackgroundColor() {
    switch (this.type) {
      case 'reserved':
        return '#B00020';
      case 'top':
        return '#9C8875';
      case '3d-tour':
        return '#5D6291';
    }
  }
}
